import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_19: FaireProductEntity = {
  token: "caden-lane-19",
  type: "product",
  name: "Lane Convertible Diaper Bag Tote | Matcha",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/b377eef306bd2e8fdffe67c140575fb180abc0b3a8a7595f5cab08a3669af9c3.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 32,
  msrpDollars: 64,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_baby-accessories"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
